/**
 * BrandSection — language-agnostic assets shared across the page.
 *
 * Currently:
 *   brand.logoUrl              header + footer logo (single asset)
 *   brand.faviconUrl           browser tab icon (future use)
 *
 * Other brand.* fields are edited where they're used:
 *   brand.androidUrl   → CTA section
 *   brand.contactEmail / brand.contactPhone / brand.contactWhatsapp / brand.whatsappLink → Contact section
 *   brand.{facebook,twitter,instagram,linkedin}Url → Footer section
 *
 * We keep them all under one `brand.*` key in the JSON so the public page
 * can find them in one place, but the editor surfaces each near the section
 * that's most likely to want to edit it.
 */

import { SectionPanel } from '../fields/BilingualFields'
import FileUploadField from '../fields/FileUploadField'

export default function BrandSection({ getField, setField }) {
  const setBoth = (key, val) => {
    setField('en', key, val)
    setField('ar', key, val)
  }

  return (
    <SectionPanel title="Brand & logos" subtitle="Header logo + favicon (shared across both languages)">
      <FileUploadField
        label="Header / footer logo"
        kind="logo"
        value={getField('en', 'brand.logoUrl', '')}
        onChange={(v) => setBoth('brand.logoUrl', v)}
        hint="SVG or transparent PNG works best. Leave empty to use the bundled OVACS SVG."
      />
      <FileUploadField
        label="Favicon"
        kind="image"
        value={getField('en', 'brand.faviconUrl', '')}
        onChange={(v) => setBoth('brand.faviconUrl', v)}
        hint="32x32 PNG / ICO. Future use — public page doesn't yet swap favicon at runtime."
      />
    </SectionPanel>
  )
}
